import { render, staticRenderFns } from "./NotesToggler.vue?vue&type=template&id=512c40d8&"
import script from "./NotesToggler.vue?vue&type=script&lang=js&"
export * from "./NotesToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports